import React from 'react';

export const Subtract1 = () => (
  <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3148 14.2383L0 0L14.2383 16.3148C28.0396 32.1289 28.0396 55.7063 14.2383 71.5204L0 87.8352L16.3148 73.5969C32.1289 59.7956 55.7063 59.7956 71.5204 73.5969L87.8352 87.8352L73.5969 71.5204C59.7956 55.7063 59.7956 32.1289 73.5969 16.3148L87.8352 0L71.5204 14.2383C55.7063 28.0396 32.1289 28.0396 16.3148 14.2383ZM23.3455 23.549L13.4052 13.7493L23.2049 23.6896C34.2925 34.9362 34.2925 53.0025 23.2049 64.2491L13.4052 74.1894L23.3455 64.3897C34.5921 53.3021 52.6584 53.3021 63.9051 64.3897L73.8454 74.1894L64.0456 64.2491C52.9581 53.0025 52.9581 34.9362 64.0456 23.6896L73.8454 13.7493L63.9051 23.549C52.6584 34.6366 34.5921 34.6366 23.3455 23.549Z"
      fill="#262626"
    />
  </svg>
);

export const Star4 = () => (
  <svg
    width="125"
    height="125"
    viewBox="0 0 125 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M62.1086 0L62.7709 23.9865C63.3356 44.4366 79.7809 60.8819 100.231 61.4466L124.218 62.1089L100.231 62.7712C79.7809 63.3359 63.3356 79.7811 62.7709 100.231L62.1086 124.218L61.4463 100.231C60.8816 79.7811 44.4364 63.3359 23.9862 62.7712L-0.000244141 62.1089L23.9862 61.4466C44.4364 60.8819 60.8816 44.4366 61.4463 23.9865L62.1086 0Z"
      fill="#262626"
    />
  </svg>
);
